export enum PersonDependenceStateEnum {
  ADMITTED = 1,
  REQUESTED = 2,
  NOT_ADMITTED = 3,
  NOT_REQUESTED = 4,
}
